import eventManagementRegister from '@/api/event-management-register'
import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState
}

export const getters = {}
export const mutations = {
  ...baseMutations
}
export const actions = {

  store(context, data) {
    return eventManagementRegister.store(data)
  },

}
